module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan3-2-903ad426e98e6bbb7cd0336837563779.webp";